import {GetWishlistHeaderBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import styled from 'styled-components';
import {Advertisement} from '../../../../features/Advertisement/Advertisement';

export const WishlistHeaderBannerView = (
  props: GetWishlistHeaderBannerResponse,
) => {
  const {advertisement} = props;

  if (!advertisement) {
    return null;
  }
  return (
    <Wrapper>
      <Advertisement
        advertisement={advertisement}
        slim
        testId="advertisementWishlist"
        tracking={{
          promotionSource: TrackingPromotionCreative.BasWishlistBanner,
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;
